export default "__VITE_ASSET__CignZhSX__"